import { Button, Icon } from '@smartgift/frontend-toolkit';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Notification } from '@hero/atoms';
import { ImagePreview } from '@hero/molecules';

import * as S from './style';

export default function PreviewSection({ giftWrapperUrl, onSelectGiftWrapperUrl }) {
  const { t } = useTranslation();
  const [isPreviewShown, setIsPreviewShown] = useState(false);

  return (
    <S.PreviewSectionWrapper>
      {isPreviewShown ? (
        <Notification
          message={
            <Trans
              i18nKey="previewSectionNotification"
              components={{
                button: (
                  <Button
                    variant="link"
                    color="secondary"
                    onClick={() => onSelectGiftWrapperUrl({ giftWrapperUrl })}
                  />
                ),
                b: <b />
              }}
            />
          }
          status="info"
          style={{ marginTop: '16px' }}
          isClosable
          onClose={() => setIsPreviewShown(false)}
          icon={
            <ImagePreview
              src={giftWrapperUrl}
              width={48}
              isWrapper={true}
              hasRadio={false}
              style={{ border: '1px solid var(--color-accent-primary-default)' }}
            />
          }
        />
      ) : (
        <Button
          variant="link"
          color="primary"
          startIcon={<Icon name="preview" />}
          onClick={() => setIsPreviewShown(true)}
        >
          {t('showDefaultWrapper')}
        </Button>
      )}
    </S.PreviewSectionWrapper>
  );
}
